var React = require('react');

function StreamlineIconShareExternalLink1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"},React.createElement("g",null,[React.createElement("path",{"d":"M23.25,0h-8a.74.74,0,0,0-.69.47.74.74,0,0,0,.16.81L18,4.51l-9.45,9.3a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.7-.28l9.48-9.33,3.29,3.24a.74.74,0,0,0,.53.22.72.72,0,0,0,.29-.06A.74.74,0,0,0,24,8.62V.75A.76.76,0,0,0,23.25,0Z","key":0}),React.createElement("path",{"d":"M18.5,10.62a1,1,0,0,0-1,1V22H2V6.5H12.37a1,1,0,0,0,0-2H1.87A1.87,1.87,0,0,0,0,6.37V22.12A1.88,1.88,0,0,0,1.87,24H17.62a1.88,1.88,0,0,0,1.88-1.88V11.62A1,1,0,0,0,18.5,10.62Z","key":1})])));
}

StreamlineIconShareExternalLink1.defaultProps = {"viewBox":"0 0 140 140"};

module.exports = StreamlineIconShareExternalLink1;

StreamlineIconShareExternalLink1.default = StreamlineIconShareExternalLink1;
